import './App.css';
import SideBar from './components/Sidebar';
import Location from './components/Location';
import Mealtime  from './components/Mealtime';
import FoodItem from './components/FoodItem';
import Comments from './components/Comments'
import { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
// import FoodItemCard from './FoodItemCard';


function App() {
    const [ name, setName ] = useState("");
    const [ description, setDescription ] = useState("");
    const [ foodItems, setFoodItems] = useState([]);
    const [ location, setLocation] = useState("The Eatery at Stetson East");
    const [ time, setTime] = useState("Lunch");

    async function CallBack (value) {
      setLocation(value.name);
      try {
        const { data, error } = await supabase
        .from("Food Items")
        .select("*")
        .eq(time, true)
        .eq("Location", value.name);
        if (error) throw error;
        if (data != null) {
          setFoodItems(data);
        }
       } catch (error) {
        alert(error.message);
      }
    }

    async function CallBack2 (value) {
      setTime(value.name);
      try {
        const { data, error } = await supabase
        .from("Food Items")
        .select("*")
        .eq(value.name, true)
        .eq("Location", location);
        if (error) throw error;
        if (data != null) {
          setFoodItems(data);
        }
       } catch (error) {
        alert(error.message);
      }
    }


    // console.log(name);
    // console.log(description);

    useEffect(() => {
      getFoodOptions();
    }, [])

    async function getFoodOptions() {
      try {
        const { data, error } = await supabase
        .from("Food Items")
        .select("*")
        .eq(time, true)
        .eq("Location", location);
        if (error) throw error;
        if (data != null) {
          setFoodItems(data);
        }
       } catch (error) {
        alert(error.message);
      }
    }

    // console.log(foodItems);

    return (
      <div className="App">
        <header className="App-header">
          <div class='z-10'>
            <SideBar />
          </div>
          <div class='pt-14 pb-4'>
             <Location handleCallBack={CallBack}/>
             <Mealtime handleCallBack={CallBack2}/>
          </div>
          <p>Rate food</p>
          <div>
          {foodItems.map((foodItem) => (
            <FoodItem foodItem = {foodItem} />
          ))}
          </div>
        </header>
        <body>
        </body>
      </div>
    );
}



export default App;
